import Velocity from 'velocity-animate'

const easing = [0.25, 0.8, 0.25, 1]

export default {
  methods: {
    enter (el, done) {
      let container = document.getElementById('primary-nav')
      Velocity(el, 'slideDown', { easing, duration: 350 })
      // Slide into view - don't assume sidebar is parent container
      if (container) {
        Velocity(el, 'scroll', { container, offset: -100, complete: done })
      } else {
        Velocity(el, 'scroll', { complete: done })
      }
    },
    leave (el, done) {
      Velocity(el, 'slideUp', { easing, duration: 350, complete: done })
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/src/mixins/sidebar.js